import { describeError } from './piEnvelope.js';
import { EMPTY, formatDate, formatDateFull, formatTime, toInstant } from './piFormat.js';
import { envelopeStatus } from './piState.js';

export const BLOCKING_ERROR_KINDS = ['session', 'disabled', 'forbidden'];

export const blankRequest = () => ({ loading: false, error: null, envelope: null, seq: 0, key: null, loaded: false });

export const objectOf = (value) => (value && typeof value === 'object' && !Array.isArray(value) ? value : {});

export const listOf = (value) => (Array.isArray(value) ? value.filter(Boolean) : []);

export const payloadOf = (envelope) => objectOf(envelope && envelope.data);

export const listPayloadOf = (envelope) => listOf(envelope && envelope.data);

export const shouldLoad = (request, key, force) => !!force || !request || request.key !== key;

export const isBlocking = (error) => !!error && BLOCKING_ERROR_KINDS.indexOf(error.kind) !== -1;

export const runRequest = (request, loader, action, key) => {
  request.seq += 1;
  const seq = request.seq;
  request.key = key === undefined ? null : key;
  request.loading = true;
  request.error = null;
  let pending;
  try {
    pending = Promise.resolve(loader());
  } catch (e) {
    pending = Promise.reject(e);
  }
  return pending
    .then((envelope) => {
      if (seq !== request.seq) return false;
      request.envelope = envelope || null;
      request.loaded = true;
      return true;
    }, (error) => {
      if (seq !== request.seq) return false;
      request.envelope = null;
      request.error = typeof action === 'function' ? action(error) : describeError(error, action);
      return false;
    })
    .then((applied) => {
      if (seq === request.seq) request.loading = false;
      return applied;
    });
};

export const failRequest = (request, error, key) => {
  request.seq += 1;
  request.key = key === undefined ? null : key;
  request.loading = false;
  request.envelope = null;
  request.error = error;
};

export const cancelRequest = (request) => {
  request.seq += 1;
  request.key = null;
  request.loading = false;
  request.error = null;
  request.envelope = null;
  request.loaded = false;
};

const coverageDay = (value) => (typeof value === 'string' && formatDateFull(value) !== EMPTY ? value.substring(0, 10) : null);

const coverageText = (started, backfilled) => {
  const parts = [];
  if (started) parts.push('Coleta desde ' + formatDateFull(started));
  if (backfilled) parts.push((started ? 'retroativo derivado desde ' : 'Retroativo derivado desde ') + formatDateFull(backfilled));
  return parts.join(', ');
};

export const coverageGroups = (envelopes, labels) => {
  const names = Array.isArray(labels) ? labels : [];
  const groups = [];
  (Array.isArray(envelopes) ? envelopes : []).forEach((envelope, index) => {
    if (!envelope) return;
    const status = envelopeStatus(envelope);
    const started = coverageDay(status.collectionStartedAt);
    const backfilled = coverageDay(status.backfilledFrom);
    if (!started && !backfilled) return;
    const key = (started || '') + '|' + (backfilled || '');
    let group = groups.filter((item) => item.key === key)[0];
    if (!group) {
      group = { key: key, text: coverageText(started, backfilled), labels: [] };
      groups.push(group);
    }
    const label = typeof names[index] === 'string' ? names[index].trim() : '';
    if (label && group.labels.indexOf(label) === -1) group.labels.push(label);
  });
  return groups;
};

export const combineEnvelopes = (envelopes, labels) => {
  const statuses = listOf(envelopes).map(envelopeStatus);
  if (!statuses.length) return null;
  let oldest = null;
  statuses.forEach((status) => {
    const instant = toInstant(status.asOf);
    if (instant && (oldest === null || instant.getTime() < oldest.getTime())) oldest = instant;
  });
  const versions = [];
  statuses.forEach((status) => {
    if (status.definitionVersion !== null && versions.indexOf(status.definitionVersion) === -1) versions.push(status.definitionVersion);
  });
  versions.sort((a, b) => a - b);
  const groups = coverageGroups(envelopes, labels);
  const coverage = groups.map((group) => (groups.length > 1 && group.labels.length ? group.text + ' (' + group.labels.join(', ') + ')' : group.text));
  return {
    asOfText: oldest ? 'Atualizado em ' + formatDate(oldest) + ' às ' + formatTime(oldest) : '',
    versionText: versions.length ? (versions.length === 1 ? 'Definição v' : 'Definições v') + versions.join(', v') : '',
    coverageText: coverage.join(' · '),
    coverageItems: coverage,
    partial: statuses.some((status) => status.partial),
    sources: statuses.length,
  };
};



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/piRequests.js